import {
  dashboard20240730Client,
  DashboardApi20240730
} from '@sequencehq/api/dashboard/v20240730'
import { throwApiError } from 'modules/Cube/utils/throwApiError'

export type v1ApiNewBillingSchedule =
  DashboardApi20240730.PostBillingSchedule.PostBillingScheduleBody
export type v1ApiUpdateBillingSchedule =
  DashboardApi20240730.PutBillingSchedule.PutBillingScheduleBody
type BillingSchedule = DashboardApi20240730.PostBillingSchedule.Response['data']

type UseSaveBillingSchedule = () => {
  createBillingSchedule: (
    billingSchedule: v1ApiNewBillingSchedule
  ) => Promise<BillingSchedule>
  updateBillingSchedule: (args: {
    id: string
    data: v1ApiUpdateBillingSchedule
  }) => Promise<BillingSchedule>
}

export const useSaveBillingSchedule: UseSaveBillingSchedule = () => {
  const createBillingSchedule = async (data: v1ApiNewBillingSchedule) => {
    const response = await dashboard20240730Client.postBillingSchedule({
      body: {
        ...data,
        isDraft: true
      }
    })

    if (response.error) {
      await throwApiError(response.res)
    }
    /**
     * During refactor it was discovered that the response here is no longer
     * aligned with reality - the post version of the schedule lacks the type
     * and attachmentAssets fields. This results in type errors if passing
     * back the response directly. The refactor in question is already hefty
     * (related to mock tweaks), so also diving into making sure these types
     * make sense is a bit much. I've, therefore, used a cast to retain the
     * old (technically incorrect) path for the meantime.
     */
    return response.data as BillingSchedule
  }

  const updateBillingSchedule = async ({
    id,
    data
  }: {
    id: string
    data: v1ApiUpdateBillingSchedule
  }) => {
    const response = await dashboard20240730Client.putBillingSchedule({
      id,
      body: data
    })

    /**
     * During refactor it was discovered that the response here is no longer
     * aligned with reality - the post version of the schedule lacks the type
     * and attachmentAssets fields. This results in type errors if passing
     * back the response directly. The refactor in question is already hefty
     * (related to mock tweaks), so also diving into making sure these types
     * make sense is a bit much. I've, therefore, used a cast to retain the
     * old (technically incorrect) path for the meantime.
     */
    if (response.error) {
      await throwApiError(response.res)
    }

    return response.data as BillingSchedule
  }

  return {
    createBillingSchedule,
    updateBillingSchedule
  }
}
